import { useUsersByRole } from '@/app/hooks/useUsersByRole'
import { useEffect } from 'react'
import { useInView } from 'react-intersection-observer'

export const useSupervisorsController = () => {
  const { ref, inView } = useInView()

  const {
    data,
    isFetching,
    isLoading,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  } = useUsersByRole('SUPERVISOR')

  useEffect(() => {
    if (inView) {
      fetchNextPage()
    }
  }, [fetchNextPage, inView])

  return {
    ref,
    data,
    isFetching,
    isLoading,
    hasNextPage,
    isFetchingNextPage,
  }
}
